import { Col, Row } from "antd";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";
import InputComponent from "../../../components/InputComponent";
import { useEffect, useState } from "react";

const Info = () => {
	const { cdnFileData, cdnFileDetail, setCDNFileData } = useCDNFileContext();
	const [name, setName] = useState<string | undefined>(cdnFileDetail?.name);

	useEffect(() => {
		setName(cdnFileDetail?.name);
	}, [cdnFileDetail?.name]);

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<InputComponent
						title={"Dosya Adı"}
						placeholder="Örnek Dosya Adı"
						value={name}
						isRequired
						onChange={(e) => {
							setName(e.target.value);
							setCDNFileData({ ...cdnFileData, name: e.target.value });
						}}
					/>
				</Col>
			</Row >
		</>
	);
};

export default Info;
